import BarChart from "~/ui-rtk/components/ui/charts/BarChart/BarChart"
import ChartLoader from "~/ui-rtk/components/ui/charts/ChartLoader"
import { Card } from "~/ui-rtk/components/ui/common"
import { H4 } from "~/ui-rtk/components/ui/typography"
import {
  VISUALIZATIONS_MAP,
  VISUALIZATION_TYPE,
} from "~/ui-rtk/constants/charts"
import useSources from "~/ui-rtk/hooks/sources"

export const WIDGET = "mentions_sentiment_by_theme_chart"

export default function SentimentByThemeChart({
  dateRange,
  compareRange,
}: {
  dateRange: [Date, Date]
  compareRange?: [Date, Date]
}) {
  const visualization = VISUALIZATIONS_MAP[WIDGET]
  const { sources } = useSources()

  return (
    <Card
      className="bg-system-blue-800 h-full rounded-system-md"
      role="region"
      aria-label="Average sentiment by theme chart"
    >
      <H4>Avg Sentiment by Theme</H4>
      <ChartLoader
        chartId={WIDGET}
        className="border-0 h-[calc(100%-1rem)]"
        widgetType={VISUALIZATION_TYPE.BarChart}
        component={BarChart}
        dateRange={dateRange}
        compareRange={compareRange}
        key={WIDGET}
        sources={sources}
        hideAggSelector={true}
        requiredSources={visualization?.requiredSources}
        cubeQueryParams={{
          [WIDGET]: {},
        }}
        description={visualization?.description ?? undefined}
        compareMode={false}
        disableGranularity={true}
        {...visualization?.props}
      />
    </Card>
  )
}
